import React from 'react';
import { NavLink } from 'react-router-dom';
import './Navigation.css';

function Navigation() {
    const navClass = ({ isActive }) => (isActive ? 'is-active' : undefined);

    return (
        <nav className="navigation" aria-label="Primary navigation">
            <ul>
                <li><NavLink to="/" end className={navClass}>Home</NavLink></li>
                <li><NavLink to="/portfolio" className={navClass}>Portfolio</NavLink></li>
                <li><NavLink to="/about" className={navClass}>About</NavLink></li>
                <li><NavLink to="/contact" className={navClass}>Contact</NavLink></li>
            </ul>
        </nav>
    );
}

export default Navigation;
